// extracted by mini-css-extract-plugin
export default {"buttons":"headerNav_buttons__L-2Pk","button":"headerNav_button__pVHyc","active":"headerNav_active__kR-TB","icon":"headerNav_icon__QOT3X"};